import { Resources } from 'constants/resources';

import { usePermissions } from 'hooks/usePermissions';
import { CreateButton } from 'shared/mui/Buttons';
import { ListPage } from 'shared/react-admin/Pages';
import { Permission } from 'types/embedded/permission';

import { CommissionsListContent } from './CommissionsListContent';

export const CommissionsList: React.FC = () => {
  const { hasResourcePermissions } = usePermissions();

  return (
    <ListPage
      actions={[
        hasResourcePermissions(Resources.Commissions, [Permission.Full, Permission.Create]) && (
          <CreateButton key="create-comissions" />
        ),
      ]}
      empty={false}
      headerTitle={{
        titleText: 'Комиссии',
        tooltipText: 'Данные, на основе которых рассчитываются комиссии, взимаемые провайдером.',
      }}
      listBoxProps={{
        sx: { maxHeight: 'initial' },

        overflow: 'auto',
      }}
      pagination={false}
      sort={{ field: 'id', order: 'DESC' }}
    >
      <CommissionsListContent />
    </ListPage>
  );
};
